enum Pages {
    Main = "/",
    Login = "/login",
    ContactUs = "/contact-us",
    InquiryCar = "/inquiry/car",
    JetClubPlans = "/jet-club-plans",
    GroupFacilities = "/group-facilities",
    InquiryCarViolation = "/inquiry/car-violation",
    InquiryCarGroupViolation = "/inquiry/car-group-violation",

    Register = "/register",
    VerifyOtp = "/verify-otp",
    LoanGuide = "/loan-guide",

    Dashboard = "/dashboard",
    Wallet = "/dashboard/wallet",
    Tickets = "/dashboard/tickets",
    Profile = "/dashboard/profile",
    JetClub = "/dashboard/jet-club",
    JetCard = "/dashboard/jet-card",
    WorkFlow = "/dashboard/work-flow",
    UserPanel = "/dashboard/user-panel",
    Facilities = "/dashboard/facilities",
    GiftCredit = "/dashboard/gift-credit",
    Transactions = "/dashboard/transactions",
    SelectFacility = "/dashboard/select-facility",
    CreditTransfer = "/dashboard/credit-transfer",
    LoanPayment = "/dashboard/payment/loan-payment",
    PaymentInstallments = "/dashboard/payment/installments",
};
export default Pages;